import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TelecomBundleForm } from '@app/form/components/telecom-bundle-selection/telecom-bundle-selection.constants';
import { Move } from '@app/move/interfaces/move';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { Navigation } from '@app/navigation/enums/navigation.enum';
import { AppNavigationSandbox } from '@app/navigation/sandboxes/navigation.sandbox';
import { WizardService } from '@app/ui/wizard/wizard.service';
import { TelecomBundle } from '@app/wizard/telecom/telecom.interfaces';
import { DbUtils } from '@smooved/core';
import { BehaviorSubject } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { TotsProvidersModule } from './tots-providers.module';
import { baseRoute, FormControlGroups, FormControlNames, steps, TelecomStep } from './tots-wizard.constants';

@Injectable({
    providedIn: TotsProvidersModule,
})
export class TotsWizardService extends WizardService {
    public loading$ = new BehaviorSubject<boolean>(false);

    constructor(
        protected readonly router: Router,
        protected readonly location: Location,
        private readonly fb: UntypedFormBuilder,
        private readonly navigationSandbox: AppNavigationSandbox,
        private readonly moveSandbox: MoveSandbox
    ) {
        super(router, location);
        this.setBaseRoute(baseRoute);
        this.setSteps(steps);
        this.form = this.fb.group({
            [FormControlGroups.StepInterest]: this.fb.group({
                [FormControlNames.Interest]: [null, Validators.required],
            }),
            [FormControlGroups.StepQualification]: this.fb.group({
                [FormControlNames.Bundle]: [{ [TelecomBundleForm.TelecomBundle]: { [TelecomBundle.Internet]: true } }, Validators.required],
                [FormControlNames.Provider]: [null, Validators.required],
            }),
        });
    }

    public onSubmitWizard(move: Move): void {
        this.moveSandbox.move$
            .pipe(
                take(1),
                tap((move) => {
                    this.moveSandbox.setMoveState({
                        ...move,
                        firstNameLeaver: move.firstNameLeaver,
                        phoneNumberLeaver: move.phoneNumberLeaver,
                        emailLeaver: move.emailLeaver,
                        languageLeaver: move.languageLeaver,
                        leaverType: move.leaverType,
                    });
                })
            )
            .subscribe();

        if (move.createdByFlow?.lp) {
            if (move.linkedMove) {
                this.moveSandbox.fetch(
                    DbUtils.getStringId(move),
                    () => void this.router.navigate([Navigation.OTS, Navigation.LeaverDetails])
                );
                return;
            }
            this.goToStep(TelecomStep.Success);
            return;
        }

        if (move.user?.landAgent) {
            void this.navigationSandbox.goToEotsMeterReadings({ eots: true });
            return;
        }
        void this.navigationSandbox.goToOtsSuccess();
    }

    public reset(): void {
        this.form.reset({
            [FormControlGroups.StepQualification]: {
                [FormControlNames.Bundle]: { [TelecomBundleForm.TelecomBundle]: { [TelecomBundle.Internet]: true } },
            },
        });
    }
}
